import { setAuthManager, setCurrentAppName } from '@doltech/core/lib/auth/authManager';
import { NoopAuthManager } from '@doltech/core/lib/auth/class/NoopAuthManager';

export const bootstrapBrowserAuthManager = () => {
  setAuthManager(new NoopAuthManager());
  setCurrentAppName('landing-blog-detail');
};
